<template>
  <footer class="footer">
    <div class="content has-text-centered">
      <p>
        <strong>小黄书</strong> by
        <a href="https://jgthms.com">xiaohuangshu</a>
      </p>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
  props: {
    book_name: String
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../style/variable.scss";
footer {
  background-color: $headfoot-bg;
}
</style>
